import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchLinks(orderId) {
  return dispatch => {
    myGet(dispatch, servAddr + 'link', {
      params: {order_id: orderId}
    }).then((response) => {
      dispatch({type: "FETCH_LINKS", payload: {links:response.data,order_id:orderId}});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function editLink(link, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.link_post === 1 ? 'link' :
    'link_assigned';
  return dispatch => {
    myPost(dispatch, servAddr + model, link).then((response) => {
      cb();
      if (link.link_id) {
        dispatch({type: "EDIT_LINK", payload: link});
      }
      else {
        dispatch({
          type: "CREATE_LINK",
          payload: {
            ...link,
            link_id:response.data.id
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/linkActions.js